<ng-container [formGroup]="form">
  <app-base-field-html [form]="form" [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                       [hideField]="hideField" [scrollContainer]="scrollContainer" [inputId]="inputId"
                       (emitPush)="push()">


    <div [ngClass]="{'uk-disabled': readonly}">
      @if (fieldData.typeInfo.multiplicity) {

      } @else {
        <div class="radio-container uk-padding-small uk-width-1-1 uk-child-width-expand" [id]="inputId">
          @if (text_left) {
            <div class="uk-form-label uk-flex uk-flex-center">{{text_left}}</div>
          }
          @for (radio of fieldData.typeInfo.values; track radio; let i = $index) {
            <div class="radio-button">
              <label for="radio-{{i}}" class="radio-label uk-form-label uk-margin-small-bottom">{{radio.label}}</label>
              <input type="radio" id="radio-{{i}}" class="uk-radio"
                     [formControlName]="fieldData.name" [name]="fieldData.name" [value]="radio.id"
                     (focusin)="focus()" (focusout)="focusOut(true)"
                     [ngClass]="{'uk-form-danger': checkFormValidity()}">
            </div>
          }
          @if (text_right) {
            <div class="uk-form-label uk-flex uk-flex-center">{{text_right}}</div>
          }
        </div>
      }
    </div>

  </app-base-field-html>
</ng-container>
